import React from "react";
import { Col, Row } from "reactstrap";
import FileItem from "./FileItem";
import "./index.scss";
const FileList = ({ list, selectedDoc, selectedFileId, favUnfavDoc,selectedIconId,fileStatus,_editDocument,label }) => {
	const _selectedDoc = (id) => {
		selectedDoc(id);
	};
	const _favUnfavDoc = (favorite, id) => {
		favUnfavDoc(favorite, id);
	};
	return (<>
			<Row>
				{
					list.map((i, index) => {
						return <Col key={i._id} md="4" xl="3">
							<FileItem
								handleSelectedDoc={(id) => _selectedDoc(id)}
								data={i}
								fileStatus={fileStatus}
								selectedFileId={selectedFileId}
								selectedIconId={selectedIconId}
								handleFavUnfavDoc={(status, id) => { _favUnfavDoc(status, id) }}
								__editDocument={_editDocument} 
								 _label={label}	
								/>
						</Col>
					})
				}
			</Row>
		</>
	);
}

export default FileList;